/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedExperienceLevelDropdownQueryResponse,
  GetApiV1PersonSharedExperienceLevelDropdown401,
  GetApiV1PersonSharedExperienceLevelDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedExperienceLevelDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedExperienceLevelDropdown } from "../../clients/personSharedController/getApiV1PersonSharedExperienceLevelDropdown.ts";

export const getApiV1PersonSharedExperienceLevelDropdownQueryKey = () =>
  [{ url: "/api/v1/person/shared/experience-level-dropdown" }] as const;

export type GetApiV1PersonSharedExperienceLevelDropdownQueryKey = ReturnType<
  typeof getApiV1PersonSharedExperienceLevelDropdownQueryKey
>;

export function getApiV1PersonSharedExperienceLevelDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedExperienceLevelDropdownQueryKey();
  return queryOptions<
    GetApiV1PersonSharedExperienceLevelDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedExperienceLevelDropdown401
      | GetApiV1PersonSharedExperienceLevelDropdown500
    >,
    GetApiV1PersonSharedExperienceLevelDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedExperienceLevelDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as opções do enumerador EExperienceLevel para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de nível de experiência para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/experience-level-dropdown}
 */
export function useGetApiV1PersonSharedExperienceLevelDropdown<
  TData = GetApiV1PersonSharedExperienceLevelDropdownQueryResponse,
  TQueryData = GetApiV1PersonSharedExperienceLevelDropdownQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1PersonSharedExperienceLevelDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedExperienceLevelDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedExperienceLevelDropdown401
          | GetApiV1PersonSharedExperienceLevelDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedExperienceLevelDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1PersonSharedExperienceLevelDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedExperienceLevelDropdown401
      | GetApiV1PersonSharedExperienceLevelDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
